define.alias("shared/components/shared/ui/navigation-arrows", "settings/components/shared/ui/navigation-arrows");